import { render, staticRenderFns } from "./ModalCreateOrganizationApiContent.vue?vue&type=template&id=b1a46374&scoped=true"
import script from "./ModalCreateOrganizationApiContent.vue?vue&type=script&lang=js"
export * from "./ModalCreateOrganizationApiContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a46374",
  null
  
)

export default component.exports